import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './FAQs.module.css';

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How accurate are the quick quotes provided on this website?",
      answer: "Our quick quotes are designed to give you a ballpark estimate based on common configurations. While they're generally accurate, the final price may vary depending on specific customizations or unique project requirements. For a precise quote, we recommend contacting our team directly."
    },
    {
      question: "Are quotes truly free?",
      answer: "Yes, absolutely! We provide free quotes with no obligation. The only exception is if a site visit is required. In case the quote is not accepted, a site visit fee is applicable. However, if the quote is accepted, the fee is waived."
    },
    {
      question: "Is there a minimum charge for a project?",
      answer: "Yes, the minimum charge for any project is $500. If your project cost is less than this amount you will still be charged the minimum amount."
    },
    {
      question: "What colors do you stock? Can you do custom colors?",
      answer: "We stock two of our most popular colors: textured black and gloss white. We also offer custom color options to match your specific needs. Custom colors may affect pricing and lead times, so please inquire for more details."
    },
    {
      question: "Can you make customizations to my railing? How much do you charge for this?",
      answer: "We offer various customization options for our railings. The cost depends on the specific modifications required. Please contact us with your needs for a custom quote."
    },
    {
      question: "What are the turn-around times?",
      answer: "Our turn-around time can be as little as one day! Custom orders or large projects may require additional time."
    },
    {
      question: "Do you install the railings as well or do we have to install them ourselves?",
      answer: "We offer both options. Our professional installation service ensures proper installation, but our railings are also designed for easy DIY installation."
    },
    {
      question: "Are the railings code compliant?",
      answer: "Yes, all our railings are designed to meet or exceed local and national building codes."
    },
    {
      question: "Are the railings engineered? Can you provide engineering drawings?",
      answer: "Yes, our railings are engineered to meet standards. Engineering drawings can be provided upon request at an additional cost."
    },
    {
      question: "What materials do you use for your railings?",
      answer: "We use high-quality aluminum alloys for our railings and tempered safety glass for our glass railings."
    },
    {
      question: "Do you offer a warranty on your products?",
      answer: "Yes, all our railings come with a 1-year limited warranty against defects in materials and workmanship."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleFAQ(index);
    }
  };

  return (
    <div className={styles.faqsContainer}>
      <Helmet>
        <title>FAQs - BGRS - Builder Grade Railing System</title>
        <meta name="description" content="Frequently asked questions about our railing systems." />
      </Helmet>
      <h1 className={styles.faqsTitle}>Frequently Asked Questions</h1>
      <div className={styles.faqsList}>
        {faqs.map((faq, index) => (
          <div key={index} className={styles.faqItem}>
            <button
              className={`${styles.faqQuestion} ${activeIndex === index ? styles.active : ''}`}
              onClick={() => toggleFAQ(index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              aria-expanded={activeIndex === index ? 'true' : 'false'}
              aria-controls={`faq-answer-${index}`}
              id={`faq-question-${index}`}
              tabIndex="0"
            >
              {faq.question}
              <span className={styles.arrow}>▼</span>
            </button>
            <div
              id={`faq-answer-${index}`}
              className={`${styles.faqAnswer} ${activeIndex === index ? styles.active : ''}`}
              role="region"
              aria-labelledby={`faq-question-${index}`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;